import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { IAlertDialogProps } from '../alert-dialog/types/alert-dialog-props';

interface IInformationDialogProps extends IAlertDialogProps {
  closeHandler: () => void;
}

export default function InformationDialog({
  closeHandler,
  isDialogOpen,
  message,
  title
}: IInformationDialogProps) {
  return (
    <Dialog
      open={isDialogOpen}
      onClose={closeHandler}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          variant='outlined'
          onClick={closeHandler}
          autoFocus
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
